import { render, staticRenderFns } from "./Silverdor.vue?vue&type=template&id=6b0158d3&scoped=true&"
import script from "./Silverdor.vue?vue&type=script&lang=js&"
export * from "./Silverdor.vue?vue&type=script&lang=js&"
import style0 from "./Silverdor.vue?vue&type=style&index=0&id=6b0158d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0158d3",
  null
  
)

export default component.exports